import { render } from "./PaletteList.vue?vue&type=template&id=7a996065"
import script from "./PaletteList.vue?vue&type=script&lang=js"
export * from "./PaletteList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Git\\led2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__